import { FC } from 'react';
import { Tabs, FormInstance } from 'antd';
import { SeoTab } from '../SeoTab';
import { ImagesVideoTab } from '../ImagesVideoTab';
import { BlogGeneralTab } from './BlogGeneralTab/BlogGeneralTab';

type Props = {
  generalTabProps: {
    data: any;
    form: FormInstance;
  }
};

export const BlogTabs: FC<Props> = ({ generalTabProps }) => {
  return (
    <Tabs
      defaultActiveKey="1"
      type="card"
      tabBarGutter={5}
      items={[
        {
          key: 'generalTab',
          label: 'Основное',
          children: <BlogGeneralTab {...generalTabProps} />,
        },
        {
          key: 'imagesVideoTab',
          label: 'Изображениe и видео',
          children: <ImagesVideoTab {...generalTabProps} hasVideoGallery />,
        },
        {
          key: 'seoTab',
          label: 'SEO',
          children: <SeoTab />,
        },
      ]}
    />
  );
};